import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-menu-side',
  templateUrl: './menu-side.component.html',
  styleUrls: ['./menu-side.component.scss']
})
export class MenuSideComponent implements OnInit {
  @Input() fade_das: boolean;
  @Output() position = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  change_dash(value) {
    this.position.emit(value);
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/menu-side/menu-side.component.ts